export const APP_SESSION_STATE_CHANGED_EVENT = "cp-session-state-changed";

export const SESSION_STATE_ACTION = Object.freeze({
  START_SESSION: "start_session",
  STOP_SESSION: "stop_session",
  START_BREAK: "start_break",
  STOP_BREAK: "stop_break",
});

/**
 * Notify mounted screens to reload session-dependent data.
 * @param {{ action?: string }} [detail]
 */
export function dispatchSessionStateChanged(detail = {}) {
  window.dispatchEvent(
    new CustomEvent(APP_SESSION_STATE_CHANGED_EVENT, { detail }),
  );
}
